<template>
  <path
    d="M21 3.00024H3C1.9 3.00024 1 3.90024 1 5.00024V17.0002C1 18.1002 1.9 19.0002 3 19.0002H8V20.0002C8 20.5502 8.45 21.0002 9 21.0002H15C15.55 21.0002 16 20.5502 16 20.0002V19.0002H21C22.1 19.0002 22.99 18.1002 22.99 17.0002L23 5.00024C23 3.90024 22.1 3.00024 21 3.00024ZM20 17.0002H4C3.45 17.0002 3 16.5502 3 16.0002V6.00024C3 5.45024 3.45 5.00024 4 5.00024H20C20.55 5.00024 21 5.45024 21 6.00024V16.0002C21 16.5502 20.55 17.0002 20 17.0002Z"
  />
</template>
